export const COOKIE_CONSENT_KEY = "cookieConsent";

export const COOKIE_CONSENT = {
  ACCEPTED: "accepted",
  REJECTED: "rejected",
};

export const getCookieConsent = () => {
  try {
    return localStorage.getItem(COOKIE_CONSENT_KEY);
  } catch (error) {
    return null;
  }
};

export const setCookieConsent = (value) => {
  try {
    localStorage.setItem(COOKIE_CONSENT_KEY, value);
  } catch (error) {
    // Storage may be unavailable; preference simply won't persist.
  }
};

export const hasCookieConsentChoice = () => {
  const consent = getCookieConsent();
  return (
    consent === COOKIE_CONSENT.ACCEPTED || consent === COOKIE_CONSENT.REJECTED
  );
};
